import React, { useEffect, useState } from "react";
import logo from "../../Assets/svg/bell icon.svg";
import logo2 from "../../Assets/svg/IDFC new logo.svg";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";

import { useNavigate } from "react-router-dom";

import Stack from "@mui/material/Stack";
import avatar from "../../Assets/svg/avatar.svg";
import HeaderOptions from "./../HeaderOptions";
import "./header.scss";
import more from "../../Assets/svg/more options.svg";
import AccountMenu from "../modules/Menu";
import { useSelector, useDispatch } from "react-redux";
import Impact from "../../Assets/svg/Impact.js";
import { showNotified } from "../ApplicationForm/redux/actions";

function notificationsLabel(count) {
  if (count === 0) {
    return "no notifications";
  }
  if (count > 99) {
    return "more than 99 notifications";
  }
  return `${count} notifications`;
}

function Header(props) {
  const dispatch = useDispatch();

  const eduInfo = useSelector((state) => state.education.eduInfo);
  const [menuName, setMenuName] = useState("");
  const registeredData = useSelector((state) => state.register.registeredData);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const showNotify = useSelector((state) => state.application.pageInfo?.showNotify);
  
  const notifications = useSelector((state) => state.connect.notifications);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [homeElems, setHomeElems] = useState([
    { title: "My Queries", name: "queries" },
    { title: "My Application", name: "application" },

    tokenData?.applicationStatus === "Awarded"
      ? {
          title:
            eduInfo?.eduInfo?.campusSpecific === "Others"
              ? "My Scholarship Disbursement Form"
              : "My SPOC Details",
          name: "disburse",
        }
      : {},
    { title: "Logout", name: "logout" },
  ]);
  const navigate = useNavigate();
  const [Link, setLink] = useState("");
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [options, setOptions] = useState([
    { title: "Home", name: "home" },
    { title: "Help", name: "help" },
    { title: "My Queries", name: "queries" },
    { title: "View my Application", name: "application" },
    { title: "View my Scholarship Disbursement form", name: "disburse" },
    { title: "Logout", name: "logout" },
  ]);
  const [alumniOptions, setAlumniOptions] = useState([
    { title: "My Profile", name: "profile" },
    { title: "Logout", name: "logout" },
  ]);
  const [isNotified, setNotified] = useState(false);
  const [menuEvent, setMenuEvent] = useState(null);

  const setEvent = (e) => {
    console.log("in event", e);
    setMenuEvent(e);
    // setMenuEvent(prev=> prev.replace(prev, e))
    // setTimeout(() => setMenuEvent(e), 200)
  };

  const notifyEvent = (e) => {
    console.log("in event", e);
    setMenuName(e);
    dispatch(showNotified(false))
    setNotified(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
    if (cleanedUrl.split("/")[2] === "alumni") {
      setHomeElems([{ title: "Profile", name: "profile" }, ...homeElems]);
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    // console.log("notifications modified", notifications);
  }, [notifications]);
  return (
    <div className="header">
      <div className="header-left">
        <img className="image1" src={logo2} alt="idfc logo" />

        {/* <div className="partition" />
        <Impact/> */}
        {/* <img className="image2" src={logo3} alt="idfc logo" />  */}

        {(registeredData?.info?.course.includes("ENGINEERING") || registeredData?.info?.course.includes("Engineering" ) ||
          registeredData?.info?.course.includes("MBA")) && (
          <div className="partition" />
        )}
        {(registeredData?.info?.course.includes("ENGINEERING") || registeredData?.info?.course.includes("Engineering" ) ||
          registeredData?.info?.course.includes("MBA")) && (
          // <img className="image2" src={logo3} alt="idfc logo" />
          <Impact />
        )}
      </div>
      {screenSize > 500 && <HeaderOptions isLogin={props.isLogin} />}
      {!props.isLogin && (
        <>
          {tokenData?.applicationStatus !== "Registered" && (
            <div
              onClick={(e) => setEvent(e)}
              className="pointer header-right header-text"
            >
              <IconButton
                aria-label={notificationsLabel(notifications?.length)}
              >
                <Badge
                  color={
                    notifications.length > 0 && (showNotify=== undefined ? true : showNotify) ? "secondary" : ""
                  }
                  overlap="circular"
                  badgeContent=" "
                  variant="dot"
                >
                  <img
                    onClick={() => notifyEvent("bell-menu")}
                    src={logo}
                    alt="more"
                  />
                  {/* <MailIcon /> */}
                </Badge>
              </IconButton>
            </div>
          )}
          <div
            onClick={(e) => setEvent(e)}
            className="pointer header-right header-text"
          >
            {Link.split("/")[2] !== "alumni" ? (
              <img
                onClick={() => setMenuName("avatar-menu")}
                src={screenSize > 500 ? avatar : more}
                alt="more"
              />
            ) : (
              <div
                className="image"
                onClick={() => setMenuName("avatar-menu")}
                // onClick={()=>navigate('/application/alumni/user-profile')}
              >
                {tokenData?.docs?.profilePicture?.fileBlob &&
                  docs?.profilePicture?.fileType && (
                    <img
                      className="image"
                      src={
                        "data:image/" +
                        docs?.profilePicture?.fileType +
                        ";base64," +
                        docs?.profilePicture?.fileBlob
                      }
                      alt="Preview"
                      style={{ maxWidth: "100%", height: "100%" }}
                    />
                  )}
              </div>
            )}
          </div>
          <AccountMenu
            id={menuName}
            isSmall={screenSize < 500}
            options={
              menuName === "avatar-menu"
                ? Link.split("/")[2] === "alumni"
                  ? alumniOptions
                  : screenSize > 500
                  ? homeElems
                  : options
                : notifications
            }
            menuEvent={menuEvent}
          >
            {menuName === "bell-menu" && (
              <div className="notification-div">
                <div className="notifications-top ">
                  Notifications{" "}
                  {notifications?.length && `(${notifications?.length})`}{" "}
                </div>
                {/* <div className="notifications-top-right">Read all</div> */}
              </div>
            )}
          </AccountMenu>
        </>
      )}
    </div>
  );
}

export default Header;
